import { render, staticRenderFns } from "./ProductMr.vue?vue&type=template&id=6518eda0"
import script from "./ProductMr.vue?vue&type=script&lang=js"
export * from "./ProductMr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports